import React from 'react'

export const tradeInConfig = [
  {
    categoryIds: ['29959'], // Mobile phones and accessories
    excludedCategoryIds: ['30144'], // smart watches
    heading: 'Trade in your old phone.',
    subtext: (
      <>
        Receive between <strong>£19 - £320.</strong> Get your estimated value here.
      </>
    )
  },
  {
    categoryIds: [
      '29960', // Tablets and iPad
      '30621', // Fitness and activity trackers
      '1054684', // Nintendo Switch 2 consoles
      '812421', // PS5 consoles
      '812425', // Xbox Series X consoles
      '823765', // Xbox Series S consoles
      '30144', // smart watches
      '30293' // nintendo switch consoles
    ],
    heading: 'Trade in your old device',
    subtext: 'Get your estimated value here.'
  },
  {
    categoryIds: ['29953'], // Laptops and PCs
    excludedCategoryIds: ['30274'], // iMacs
    brand: 'Apple',
    heading: 'Trade in your old device',
    subtext: 'Get your estimated value here.'
  }
]

const hasMatchingCategory = (config, breadcrumbIds) => {
  return config.categoryIds.some(id => breadcrumbIds.includes(id))
}

const hasMatchingSku = (config, sku) => {
  return config.skus && config.skus.includes(sku)
}

const isExcludedCategory = (config, breadcrumbIds) => {
  if (!config.excludedCategoryIds) return false
  return config.excludedCategoryIds.some(excluded => breadcrumbIds.includes(excluded))
}

const isBrandMismatch = (config, brand) => {
  return config.brand && config.brand !== brand
}

/**
 * Finds the matching trade-in category configuration for a product
 * @param {Array} breadcrumb
 * @param {string} brand
 * @returns {Object|undefined}
 * @param {string} sku
 */
export const getTradeInConfig = (breadcrumb, brand, sku) => {
  const breadcrumbIds = breadcrumb?.map(crumb => crumb.id) ?? []

  const skuConfig = tradeInConfig.find(
    config => config.skus && hasMatchingSku(config, sku) && !isBrandMismatch(config, brand)
  )
  if (skuConfig) return skuConfig

  return tradeInConfig.find(
    config =>
      !config.skus &&
      hasMatchingCategory(config, breadcrumbIds) &&
      !isBrandMismatch(config, brand) &&
      !isExcludedCategory(config, breadcrumbIds)
  )
}
